<div dwRow>
    <div dwCol="12">
        <label class="label">Cardholder Name</label>
        <input type="text" class="form-control" [(ngModel)]="cardDetails.cardholderName"
            (ngModelChange)="onChange()" />
    </div>
</div>
<a (click)="addTestCardInfo()" class="dw-link" *ngIf="showAddTestCardInfo"
    title="Add test card information.  This is only available outside of the live site">Add test card
    info</a>
<div dwRow>
    <div dwCol="12">
        <label class="label">Credit Card Number</label>
        <input type="text" class="form-control" [(ngModel)]="cardDetails.cardNumber"
            (ngModelChange)="onChange()" />
    </div>
</div>
<div dwRow>
    <div dwCol="6">
        <label class="label">Expiration Month</label>
        <select class="form-control" [(ngModel)]="cardDetails.expirationMonth"
            (ngModelChange)="onChange()">
            <option value="01">01</option>
            <option value="02">02</option>
            <option value="03">03</option>
            <option value="04">04</option>
            <option value="05">05</option>
            <option value="06">06</option>
            <option value="07">07</option>
            <option value="08">08</option>
            <option value="09">09</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
        </select>
    </div>
    <div dwCol="6">
        <label class="label">Expiration Year</label>
        <select class="form-control" [(ngModel)]="cardDetails.expirationYear"
            (ngModelChange)="onChange()">
            <option *ngFor="let year of years" [ngValue]="year">{{year}}</option>
        </select>
    </div>
</div>
<div dwRow>
    <div dwCol="6">
        <label class="label">CVC Code</label>
        <input type="text" class="form-control" [(ngModel)]="cardDetails.cVC"
            (ngModelChange)="onChange()" />
    </div>

    <div dwCol="6">
        <label class="label">Postal Code</label>
        <input type="text" class="form-control" [(ngModel)]="cardDetails.cardholderPostalCode"
            (ngModelChange)="onChange()" />
    </div>
</div>